import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const heavyIndustry = [
  { label: 'Mining', path: '/mining' },
  { label: 'Cement & Materials', path: '/cement' },
  { label: 'Energy & Power', path: '/energy' },
  { label: 'Oil & Gas', path: '/oil-gas' },
  { label: 'Manufacturing', path: '/manufacturing' },
  { label: 'Machinery & OEM', path: '/machinery' },
  { label: 'Construction', path: '/construction' },
];

export const IndustriesDropdown = ({ isOpen, onClose, isMobile, onMouseEnter, onMouseLeave }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };
    if (isOpen && !isMobile) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose, isMobile]);

  useEffect(() => {
    const handleEsc = (event) => { if (event.key === 'Escape') onClose(); };
    if (isOpen && !isMobile) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose, isMobile]);

  const handleItemClick = () => setTimeout(() => onClose(), 50);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      id={isMobile ? 'mega-industries-mobile' : 'mega-industries'}
      className={`mining-dropdown ${isMobile ? 'mining-dropdown-mobile' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="menu"
      aria-label="Industries menu"
      data-testid="industries-dropdown"
    >
      <div className="mining-dropdown-grid" style={{ gridTemplateColumns: '260px' }}>
        <div className="mining-category-column">
          <h4 className="mining-category-title">Heavy Industry</h4>
          <ul className="mining-subitems-list">
            {heavyIndustry.map((item, i) => (
              <li key={item.label}>
                <Link to={item.path} className="mining-subitem-link" onClick={handleItemClick} role="menuitem">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default IndustriesDropdown;
